module.exports = __webpack_public_path__ + "static/media/clothing_icon.9fc0ce6d.svg";